import {eventBus} from "@/main";

export function prepareError(errorCode, points, exception) {
    let text
    switch (errorCode) {
        case -100:
            text = 'There is no general route'
            break;
        case -9:
        case -8:
        case -7:
        case -6:
            text = 'Failed to read map data'
            break;
        case -5:
            text = 'Non-detailed cells were used'
            break;
        case -4:
            text = 'Internal error'
            break;
        case -3:
            text = 'The second passage was not found'
            break;
        case -2:
            text = 'Not all cells are loaded'
            break;
        case -1:
            text = 'Not enough cell data available for this region'
            break;
        case 1:
            text = 'Internal error'
            break;
        case 2:
            text = 'Memory lack'
            break;
        case 3:
            text = 'Wrong starting point'
            break;
        case 4:
            text = 'Wrong finish point'
            break;
        case 5:
            text = 'Wrong depth'
            break;
        case 6:
            text = 'Too long route'
            break;
        case 7:
            text = 'The first passage was not found'
            break;
        case 8:
            text = 'Internal error'
            break;
        case 9:
            text = 'Start/Finish point is in restricted zone'
            break;

        default:
            text = 'Can\'t compute the route'
    }
    text = "<div class='small-red'>" + 'Error: (' + errorCode + ') ' + text + "<br><div class='smt2s'>" + points + "</div></div>"
    if (exception)
        text += "<div class='small-red'>" + exception + "</div>"
    eventBus.$emit('show-route-error', text)
}
